import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { productStructureApi, type StructureDashboard } from '../../api/productstructure';

const NAV = [
  { to: '/product-structure/variants', label: 'Variant manager' },
  { to: '/product-structure/variant-matrix', label: 'Variant matrix' },
  { to: '/product-structure/bundles', label: 'Bundle builder' },
  { to: '/product-structure/kits', label: 'Kit builder' },
  { to: '/product-structure/relationships', label: 'Relationships' },
  { to: '/product-structure/families', label: 'Product families' },
  { to: '/product-structure/marketplace', label: 'Marketplace structure' },
  { to: '/product-structure/dependencies', label: 'Dependency graph' },
];

export function ProductStructureHubPage() {
  const [dashboard, setDashboard] = useState<StructureDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void productStructureApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Product Structure</h1>
      <p className="mt-1 text-sm text-slate-600">Variants, bundles, kits, and product relationships.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Object.entries(dashboard?.stats ?? {}).map(([k, v]) => (
          <div key={k} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{k.replace(/_/g, ' ')}</p>
            <p className="mt-1 text-2xl font-semibold">{String(v)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
